'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _portalProvider = require('./portal-provider');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var portalTarget = function portalTarget(name) {
  return function (PortalTargetComponent) {
    var PortalTargetCore = function (_Component) {
      (0, _inherits3.default)(PortalTargetCore, _Component);

      function PortalTargetCore(props) {
        (0, _classCallCheck3.default)(this, PortalTargetCore);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PortalTargetCore.__proto__ || (0, _getPrototypeOf2.default)(PortalTargetCore)).call(this, props));

        _this.state = { children: [] };
        props.portalConnector.registerTarget(name, _this);
        return _this;
      }

      (0, _createClass3.default)(PortalTargetCore, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          this.props.portalConnector.removeTarget(name, this);
        }
      }, {
        key: 'updateChildren',
        value: function updateChildren(children) {
          this.setState({ children: children });
        }
      }, {
        key: 'render',
        value: function render() {
          return _react2.default.createElement(
            PortalTargetComponent,
            null,
            this.state.children
          );
        }
      }]);
      return PortalTargetCore;
    }(_react.Component);

    var PortalTarget = function (_PureComponent) {
      (0, _inherits3.default)(PortalTarget, _PureComponent);

      function PortalTarget() {
        (0, _classCallCheck3.default)(this, PortalTarget);
        return (0, _possibleConstructorReturn3.default)(this, (PortalTarget.__proto__ || (0, _getPrototypeOf2.default)(PortalTarget)).apply(this, arguments));
      }

      (0, _createClass3.default)(PortalTarget, [{
        key: 'render',
        value: function render() {
          var _this3 = this;

          return _react2.default.createElement(
            _portalProvider.Consumer,
            null,
            function (portalConnector) {
              return _react2.default.createElement(PortalTargetCore, (0, _extends3.default)({}, _this3.props, {
                portalConnector: portalConnector
              }));
            }
          );
        }
      }]);
      return PortalTarget;
    }(_react.PureComponent);

    PortalTarget.displayName = 'portalTarget';

    return PortalTarget;
  };
};

exports.default = portalTarget;